import React, { useContext, useEffect, useState } from "react";
import { setStoredUserInfo } from "../utils/storage";
import { Grid } from "@mui/material";
import { Store } from "../Store";
import { Link, useNavigate } from "react-router-dom";
import classes from "../Assets/Styles/Signin.module.css";
import { ToastContainer, toast } from "react-toastify";
import { signInFirebaseUser, signUpUser } from "../features/auth/api";
import { golobalFont, labelColors } from "../utils/constants";
import UserLanguageSelector from "../Components/UserLanguageSelector";

const SignupScreen = () => {
  const nameInputId = "signup-name";
  const emailInputId = "signup-email";
  const passwordInputId = "signup-password";
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fluentLanguages, setFluentLanguages] = useState([]);

  const { dispatch: ctxDispatch } = useContext(Store);
  // const { userInfo } = state;

  const signUp = async (e) => {
    e.preventDefault();
    try {
      const { data } = await signUpUser({
        email,
        password,
        name,
      });
      await signInFirebaseUser({ email, password });
      toast.success("Your Account has been created successfully");
      ctxDispatch({ type: "USER_SIGNIN", payload: data });
      setStoredUserInfo(data);

      if (data.isAdmin) navigate("/adminlanding");
      else navigate("/landing");
    } catch (err) {
      toast.error("Wrong Password/Email");
    }
  };

  useEffect(() => {
    ctxDispatch({ type: "PROJECT_FILE_CLEAR" });
    // localStorage.removeItem("projectFile");
  }, [ctxDispatch]);

  return (
    <Grid
      item
      container
      direction="column"
      alignItems="center"
      marginTop={20}
      marginBottom={15.9}
    >
      <ToastContainer position="top-center" color="yellow" />
      <Grid
        item
        container
        justifyContent="center"
        justifyItems="center"
        width="40%"
        className={classes["HomeCardDetails"]}
      >
        <form onSubmit={signUp}>
          <Grid item container direction="column">
            <Grid item className={classes["header"]}>
              Create your account
            </Grid>
            <Grid item fontSize="var(--font-size-header)" marginBottom={1.5}>
              <label htmlFor={nameInputId}>
                <div className={classes["labels"]}>Name</div>
              </label>
            </Grid>
            <input
              id={nameInputId}
              type="text"
              placeholder="Enter your Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className={classes["SampleInputForm"]}
            ></input>
            <Grid item fontSize="var(--font-size-header)" marginBottom={1.5}>
              <label htmlFor={emailInputId}>
                <div className={classes["labels"]}>Email</div>
              </label>
            </Grid>
            <input
              id={emailInputId}
              type="text"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={classes["SampleInputForm"]}
            ></input>
            <Grid item fontSize="var(--font-size-header)" marginBottom={1.5} marginTop={1.5}>
              <label htmlFor={passwordInputId}>
                <div className={classes["labels"]}>Password</div>
              </label>
            </Grid>
            <input
              id={passwordInputId}
              type="password"
              placeholder="Enter your Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={classes["SampleInputForm"]}
            ></input>
            <Grid item marginTop={3}>
              <UserLanguageSelector
                selectedLanguages={fluentLanguages}
                onChange={setFluentLanguages}
              />
            </Grid>
            <Grid item marginLeft={5} marginTop={1.5}>
              <Link
                to="/"
                style={{
                  textDecoration: "none",
                  color: `${labelColors}`,
                  fontFamily: `${golobalFont}`,
                }}
              >
                <div>You already signed up? Sign in</div>
              </Link>
            </Grid>
          </Grid>
          <Grid
            item
            container
            direction="column"
            alignItems="center"
            marginTop={3.5}
            marginBottom={4}
          >
            <button type="submit" className={classes["SampleActiveButton"]}>
              Sign Up
            </button>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};

export default SignupScreen;
